<div class="maps-graphs-container">
  <ng-container *ngIf="mapData.length > 0; else noResults">
    <!-- <drag-scroll> -->
    <countries-map
      class="countries-map"
      [data]="countriesData"
      (chartSelect)="select($event)"
      id="myMapContainer"
      [showCaption]="false"
      [maxColor]="'white'"
      [minColor]="'white'">
    </countries-map>
    <app-country-details-data
      id="detailsContainer"
      [ngClass]="{ 'hidden': !isCountryDetailsVisible }"
      [selectedCountry]="selectedCountry"
      [selectedCompareCountry]="selectedCompareCountry"
      (closeDetailsPopUp)="closeDetails()"
      [compareMode]="compareMode">
    </app-country-details-data>
    <!-- </drag-scroll> -->
  </ng-container>
  <ng-template #noResults>
    <div class="no-results-container global-transition">
      <app-join-program-alert class="offer-join-alert" [type]="'info'" [containerText]="{withTranslation: true, text: 'no_results'}"></app-join-program-alert>
    </div>
  </ng-template>
</div>
